export default __webpack_public_path__ + "static/media/quick-view.1154853f.jpg";